// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__7mHqf","footer":"ModalCreateQualiphyProcedure_footer__2K3Ff","additionData":"ModalCreateQualiphyProcedure_additionData__3pWbW"};